(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/views/tt-filter-view.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/views/tt-filter-view.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.views.TTFilter = Marionette.View.extend({

    className: 'tt-filter-bar padding-1',

    template: function(data) {
      return svs.tt.templates.filter(data);
    },

    modelEvents: {
      change: 'render'
    },

    events: {
      'change .js-sport-checkbox': 'onSelectionSport'
    },

    onSelectionSport: function(data) {
      var sportIndex = parseInt(
        data.currentTarget.attributes['data-id'].value,
        10
      );
      var sportType = this.model.get('availableSports')[sportIndex].type;

      var filters = this.model.get('filters');

      filters[sportType] = data.currentTarget.checked;

      this.model.set('filters', filters, { silent: true });
      svs.tt.app.radio.trigger('filtersApplied', filters);
    }
  });
})(Backbone, _, svs);


 })(window);